export const globalSettingsProductsSdmailRoute = {
	name: 'global-settings-products-sdmail',
	path: '/secure/admin/SDMailInfo.jspa',
};
